import { render, staticRenderFns } from "./AddPPMyearly.vue?vue&type=template&id=71602de5&scoped=true&"
import script from "./AddPPMyearly.vue?vue&type=script&lang=ts&"
export * from "./AddPPMyearly.vue?vue&type=script&lang=ts&"
import style0 from "./AddPPMyearly.vue?vue&type=style&index=0&id=71602de5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71602de5",
  null
  
)

component.options.__file = "AddPPMyearly.vue"
export default component.exports